<template>
  <div v-if="isOpen" class="modal fade show" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">Asset Disposal</h1>
              <button
                  @click="onClose"
                  type="button"
                  class="btn-close"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
        <hr class="mt-0">

        <div class="pb-2">
          <div class="row gy-2 px-2">
            <div class="col-12">
              <label class="form-label" for="ongoingDate">Disposal Date</label>
              <input
                  v-model="ongoingDate"
                  id="ongoingDate"
                  class="form-control"
                  type="date"
              >
            </div>
            <div class="col-12">
              <label class="form-label" for="disposalNote">Note / Remarks</label>
              <textarea
                  v-model="disposalNote"
                  id="disposalNote"
                  class="form-control"
                  rows="3"
                  placeholder="Note / Remarks"
              ></textarea>
              <span v-if="error" class="invalid-feedback d-block">{{ error }}</span>
            </div>
          </div>

          <div class="col-12 text-center">
            <hr class="mt-2">
            <button @click="onSubmit" type="button" class="btn btn-primary me-1 mt-1">
              <div v-if="saving" class="spinner-border spinner-border-sm text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              Submit
            </button>
            <button @click="onClose" type="button" class="btn btn-outline-secondary mt-1">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, inject } from 'vue'
import { useRoute } from 'vue-router'
import useDate from '@/services/utils/day'
import handleAssetRegister from '@/services/modules/assetRegister/assetRegister'

const props = defineProps({
  isOpen: { type: Boolean, default: false },
  assetId: { type: [Number, String], default: null }
})

const emit = defineEmits(['onClose', 'onSaved'])

const route = useRoute()
const { currentDate } = useDate()
const { disposalAssetRegister } = handleAssetRegister()

const showError = inject('showError')
const showSuccess = inject('showSuccess')

const ongoingDate = ref(currentDate())
const disposalNote = ref('')
const error = ref('')
const saving = ref(false)

watch(() => props.isOpen, (open) => {
  if (!open) return
  ongoingDate.value = currentDate()
  disposalNote.value = ''
  error.value = ''
})

function onClose() {
  ongoingDate.value = currentDate()
  disposalNote.value = ''
  error.value = ''
  emit('onClose')
}

function onSubmit() {
  if (!ongoingDate.value) {
    error.value = 'Disposal date is required'
    return
  }
  if (!props.assetId) return
  error.value = ''
  saving.value = true
  const query = `?company_id=${route.params.companyId}`
  const data = { ongoing_date: ongoingDate.value, disposal_note: disposalNote.value }
  disposalAssetRegister(data, props.assetId, query)
    .then(res => {
      saving.value = false
      if (!res.status) {
        showError(res.message)
        return
      }
      showSuccess(res.message)
      emit('onSaved')
    })
    .catch(() => {
      saving.value = false
    })
}
</script>
